import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserBasicInfoFragmentDoc } from '../../communities/components/GroupMembersList/__generated__/user.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  email?: Types.InputMaybe<Types.Scalars['String']['input']>;
  username?: Types.InputMaybe<Types.Scalars['String']['input']>;
  media?: Types.InputMaybe<Types.Scalars['Upload']['input']>;
  info?: Types.InputMaybe<Types.Scalars['String']['input']>;
  firstName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  lastName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  criticalInfo?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  negativeInfo?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  positiveInfo?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  restrictedAccess?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  receiveSummaryNotificationEmails?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  visibility?: Types.InputMaybe<Types.UserVisibility>;
  tags?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', info?: string | null, restrictedAccess?: boolean | null, tags: Array<string>, id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null, profile?: { __typename?: 'Profile', id: string, criticalInfo: Array<string>, positiveInfo: Array<string>, negativeInfo: Array<string> } | null } };


export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $email: String, $username: String, $media: Upload, $info: String, $firstName: String, $lastName: String, $criticalInfo: [String!], $negativeInfo: [String!], $positiveInfo: [String!], $restrictedAccess: Boolean, $receiveSummaryNotificationEmails: Boolean, $visibility: UserVisibility, $tags: [String!]) {
  updateUser(
    data: {id: $id, email: $email, username: $username, mediaFile: $media, info: $info, firstName: $firstName, lastName: $lastName, criticalInfo: $criticalInfo, negativeInfo: $negativeInfo, positiveInfo: $positiveInfo, restrictedAccess: $restrictedAccess, receiveSummaryNotificationEmails: $receiveSummaryNotificationEmails, visibility: $visibility, tags: $tags}
  ) {
    ...UserBasicInfo
    info
    restrictedAccess
    profile {
      id
      criticalInfo
      positiveInfo
      negativeInfo
    }
    tags
  }
}
    ${UserBasicInfoFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      media: // value for 'media'
 *      info: // value for 'info'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      criticalInfo: // value for 'criticalInfo'
 *      negativeInfo: // value for 'negativeInfo'
 *      positiveInfo: // value for 'positiveInfo'
 *      restrictedAccess: // value for 'restrictedAccess'
 *      receiveSummaryNotificationEmails: // value for 'receiveSummaryNotificationEmails'
 *      visibility: // value for 'visibility'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;